import { fg } from '@confluence/feature-gating';
import { useBooleanFeatureFlag } from '@confluence/session-data';

import { LIVE_PAGES_PARENT_FF } from './featureFlags';

export const useIsLivePagesFeatureEnabled = (): boolean =>
	useBooleanFeatureFlag(LIVE_PAGES_PARENT_FF) ||
	fg('confluence_live_pages') ||
	fg('confluence_live_pages_ab_test_opted_in');
